import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useEditMode } from '../../contexts/EditModeContext';

interface SidebarProps {
  onLogout: () => void;
}

const Sidebar: React.FC<SidebarProps> = ({ onLogout }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { isEditMode } = useEditMode();

  const menuItems = [
    {
      id: 'seat-arrangement',
      path: '/',
      icon: 'ri-map-2-line',
      label: '배치',
    },
    {
      id: 'people-list',
      path: '/people',
      icon: 'ri-file-list-3-line',
      label: '리스트',
    },
  ];

  const handleMenuClick = (path: string) => {
    if (isEditMode && location.pathname !== path) {
      const confirmed = window.confirm('수정 중인 내용이 저장되지 않을 수 있습니다. 페이지를 이동하시겠습니까?');
      if (confirmed) {
        navigate(path);
      }
    } else {
      navigate(path);
    }
  };

  return (
    <div className="sidebar">
      <style>
        {`
          .sidebar {
            position: fixed;
            left: 0;
            top: 0;
            bottom: 0;
            width: 56px;
            background: #ffffff;
            border-right: 1px solid #e5e7eb;
            display: flex;
            flex-direction: column;
            z-index: 1000;

          }
          
          .sidebar-header {
            padding: 16px 0;
            border-bottom: 1px solid #e5e7eb;
            display: flex;
            height: 50px;
            justify-content: center;
            align-items: center;
          }
          
          .sidebar-logo {
            display: flex;
            align-items: center;
            justify-content: center;
            color: #374151;
            font-weight: 700;
            font-size: 16px;
          }
          
          .sidebar-menu {
            flex: 1;
            display: flex;
            flex-direction: column;
          }
          
          .menu-item {
            display: flex;
            flex-direction: column;
            align-items: center;
            gap: 4px;
            width: 100%;
            padding: 12px 8px;
            border: none;
            background: none;
            cursor: pointer;
            font-size: 10px;
            font-weight: 600;
            color: #6b7280;
            transition: all 0.2s ease;
            text-decoration: none;
            line-height: 1;
          }
          
          .menu-item:hover {
            background: #f3f4f6;
            color: #374151;
          }
          
          .menu-item.active {
            background: #dbeafe;
            color: #1d4ed8;
          }
          
          .menu-item i {
            font-size: 18px;
            margin-bottom: 2px;
            font-weight: 400;
          }
          
          .menu-label {
            font-size: 10px;
            font-weight: 600;
            line-height: 1;
          }
          
          .sidebar-footer {
            border-top: 1px solid #e5e7eb;
          }
          
          .logout-btn {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 100%;
            padding: 12px 8px;
            border-radius: 6px;
            border: none;
            background: none;
            cursor: pointer;
            color: #9ca3af;
            transition: all 0.2s ease;
          }
          
          .logout-btn:hover {
            background: #f3f4f6;
            color: #6b7280;
          }
          
          .logout-btn i {
            font-size: 18px;
          }
        `}
      </style>
      
      <div className="sidebar-header">
        <div className="sidebar-logo">P</div>
      </div>
      
      <nav className="sidebar-menu">
        {menuItems.map((item) => (
          <button
            key={item.id}
            className={`menu-item ${location.pathname === item.path ? 'active' : ''}`}
            onClick={() => handleMenuClick(item.path)}
          >
            <i className={item.icon}></i>
            <span className="menu-label">{item.label}</span>
          </button>
        ))}
      </nav>
      
      <div className="sidebar-footer">
        <button className="logout-btn" onClick={onLogout}>
          <i className="ri-logout-box-line"></i>
        </button>
      </div>
    </div>
  );
};

export default Sidebar; 